import { QueryFilters, useIsFetching } from '@tanstack/react-query';
import PageLayout from '../components/global/PageLayout';
import OnboardingBanner from '../components/onboarding/OnboardingBanner';
import useSelectWaiver from '../hooks/waivers/useSelectWaiver';
import WaiversTabs from '../components/waivers/WaiversTabs';
import WaiversTable from '../components/waivers/WaiversTable';
import useGetWaivers from '../hooks/waivers/useGetWaivers';
import PageLoading from '../components/global/PageLoading';

const IS_FETCHING_ARGS: QueryFilters = {
  exact: false,
  fetchStatus: 'fetching',
  type: 'active',
};

export default function WaiversPage() {
  const {
    waiverId: selectedWaiverId,
    waiver: selectedWaiver,
    onSelectWaiver,
  } = useSelectWaiver();
  const { isLoading } = useGetWaivers();

  const waiversFetchingCount = useIsFetching({
    ...IS_FETCHING_ARGS,
    queryKey: ['waivers'],
  });
  const requestsFetchingCount = useIsFetching({
    ...IS_FETCHING_ARGS,
    queryKey: ['waiver-requests'],
  });

  const onBack = () => {
    if (selectedWaiverId) {
      onSelectWaiver(null);
    }
  };

  return (
    <PageLayout
      onBack={selectedWaiverId ? onBack : undefined}
      topSection={<OnboardingBanner step="WAIVERS" />}
      title={selectedWaiver?.waiverName || 'Waivers'}
      isLoading={waiversFetchingCount > 0 || requestsFetchingCount > 0}>
      {isLoading ? (
        <PageLoading />
      ) : selectedWaiverId ? (
        <WaiversTabs />
      ) : (
        <WaiversTable />
      )}
    </PageLayout>
  );
}
